'use client'

import { useEffect } from 'react'

// Module-scoped dedupe set: within one browser session, the same media_item
// id counts once regardless of how many SPA navigations cross it. Day-bucket
// aggregation on the server already prevents bloat, but skipping the round-
// trip when we've already pinged keeps storefronts quieter.
const pingedIds = new Set<string>()

/**
 * Fire-and-forget ping announcing that these media items just rendered on a
 * public storefront page. Server side looks up the viewer tenant from the
 * request Host — the client never supplies it.
 *
 * Dropped in once per page, not per image. Errors are swallowed: telemetry
 * must never break the render path.
 */
export function RenderedMediaPing({ ids }: { ids: string[] }) {
  useEffect(() => {
    if (ids.length === 0) return
    const fresh = ids.filter(id => !pingedIds.has(id))
    if (fresh.length === 0) return
    fresh.forEach(id => pingedIds.add(id))
    try {
      fetch('/api/media-ping', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: fresh }),
        keepalive: true,
      }).catch(() => {})
    } catch {
      // never block render
    }
  }, [ids])
  return null
}
